import type { Experiment, Variant } from './experiments';

export function getWeightedRandomVariant(variants: Variant[]): number {
  const totalWeight = variants.reduce((sum, v) => sum + v.weight, 0);
  const random = Math.random() * totalWeight;

  let cumulative = 0;
  for (let i = 0; i < variants.length; i++) {
    cumulative += variants[i].weight;
    if (random < cumulative) {
      return i;
    }
  }

  return variants.length - 1;
}

export function getVariantFromUrl(experiment: Experiment): number | null {
  if (!experiment.urlParam) return null;
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const value = params.get(experiment.urlParam);

  if (value === null) return null;

  const variant = parseInt(value, 10);
  if (isNaN(variant) || variant < 0 || variant >= experiment.variants.length) {
    return null;
  }

  return variant;
}
